<template>
    <div class="landing-page" v-if="!user">
        <Heading/>
        <ConvertingUpdates/>
        <GrowConversions/>
        <MostBacked/>
        <AboutCrossprom/>
        <Community
            iconPrev="landing-arrow-prev"
            iconNext="landing-arrow-prev"
        />
        <Footer/>
    </div>
</template> 

<script>
import { mapState } from 'vuex'
import Heading from './Heading'
import GrowConversions from './GrowConversions/index'
import ConvertingUpdates from './ConvertingUpdates/index'
import MostBacked from './MostBacked'
import AboutCrossprom from './AboutCrossprom/index.vue'
import Community from './Community'
import Footer from './Footer'
export default {
    name: 'LandingPage',
    components: {
        Heading,
        GrowConversions,
        ConvertingUpdates,
        MostBacked,
        AboutCrossprom,
        Community,
        Footer
    },
    computed: {
        ...mapState(['user'])
    },
    mounted() {
        if(this.user) {
            this.$router.push('/browse').catch(() => {})
        }
        this.$sendMixpanelEvent('Landing Page Opened');

        this.$ga.event('Landing Page', 'Landing Page Opened');
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/variables.scss';
@font-face {
    font-family: 'EinaBold';
    src: url(../../../public/fonts/Eina04-Bold.otf);
}
.landing-page {
    background: $c14;
    p {
        &[data-type="main-text"] {
            color: $c6;
            margin-bottom: 0 !important;
        }
        &[data-name="title"] {
            font-size: 32px;
            font-family: 'EinaBold';
        }
        &[data-name="desc"] {
            font-size: 18px;
        }
    }
    .content-sm {
        max-width: 1160px;
        margin: 0 auto;
    }
    .content-lg {
        max-width: 1284px;
        margin: 0 auto;
    }
    .content-xs {
        max-width: 980px;
        margin: 0 auto;
    }
}
@media (max-width: 576px) {
.landing-page {
    p {
        &[data-name="title"] {
            font-size: 23px;
        }
    }
}
}
</style>